import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import List from 'components/Common/List'

type Props = {
  packageInclusions: Array<string>
}

function AccommodationPackageInclusions({ packageInclusions }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'g-V5wG-pK-I_u0PxnrkF',
    defaultMessage: 'Package inclusions',
    description: 'Heading for the package inclusions section within the guest policy area of the room details modal.',
  })

  return (
    <>
      <Heading variant="heading6" as="h4">{heading}</Heading>
      <List>
        {packageInclusions.map((inclusion) => (
          <BodyText key={inclusion} as="li" variant="medium">
            {inclusion}
          </BodyText>
        ))}
      </List>
    </>
  )
}

export default AccommodationPackageInclusions
